
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/premier-lounge-terms",
      function () {
        return require("private-next-pages/legal/premier-lounge-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/premier-lounge-terms"])
      });
    }
  